module.exports = __webpack_public_path__ + "img/phase2-gallery-10.4106716d.png";